import React, { useEffect, useState } from 'react';

const AnimatedCount = ({ value }) => {
    const [displayValue, setDisplayValue] = useState(value);

    useEffect(() => {
        let startValue = displayValue;
        const endValue = value;
        const duration = 500; // ms
        const startTime = performance.now();

        if (startValue === endValue) return;

        const animate = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            
            // Easing function (easeOutQuad)
            const ease = 1 - (1 - progress) * (1 - progress);
            
            const current = Math.round(startValue + (endValue - startValue) * ease);
            setDisplayValue(current);

            if (progress < 1) {
                requestAnimationFrame(animate);
            }
        };

        requestAnimationFrame(animate);
    }, [value]);

    return <span>{displayValue}</span>;
};

export default AnimatedCount;